export interface PolicyUsage {
    downloadGpxCount: number;
    cloudSaveActionCount: number;
    cloudSaveCount: number;
}

export default interface Policy {
    version: string;
    freeMaxTracks: number;
    freeDownloadGpxLimit: number;
    freeCloudSaveActionLimit: number;
    freeCloudSaveLimit: number;
    freeCanImport: boolean;
    freeCanUseSubscriberRenderers: boolean;
    freeCanUseRideWithGps: boolean;
    freeCanCloudSavePrivate: boolean;
    usage: PolicyUsage;
}

export const defaultPolicy: Policy = {
    version: 'client-default',
    freeMaxTracks: 2,
    freeDownloadGpxLimit: 5,
    freeCloudSaveActionLimit: 10,
    freeCloudSaveLimit: 2,
    freeCanImport: true,
    freeCanUseSubscriberRenderers: false,
    freeCanUseRideWithGps: false,
    freeCanCloudSavePrivate: true,
    usage: {
        downloadGpxCount: 0,
        cloudSaveActionCount: 0,
        cloudSaveCount: 0
    }
}
